module.exports = __webpack_public_path__ + "static/img/getInvitationBettingRewardsBg.6717a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/getInvitationBettingRewardsBg.png
// module id = KO2a
// module chunks = 0